/* src/app/features/prestacao-informacoes/acompanhamento-processual/acompanhamento-processual-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=acompanhamento-processual-detalhe.component.css.map */
